import React, { useEffect } from 'react'
import { useEstimateStore } from 'stores/estimateStore'
import { usePaymentStore } from '../PaymentTypeSelection'
import SleepSelectOption from '../PaymentTypeSelection/components/SleepSelectOption'
import SfRadio from 'components/overrides/SfRadio'

interface PaymentPlanProps {
  total?: number
  numberOfMonths?: number
  onLoad?: () => void
}

const PaymentPlan: React.FC<PaymentPlanProps> = ({
  total,
  numberOfMonths = 3,
  onLoad
}) => {
  const { splitPayment, setSplitPayment } = usePaymentStore()
  // Get total from estimate store if not provided as prop
  const { estimate } = useEstimateStore()

  // Use provided total or fall back to estimate total_charge or default to 0
  const paymentTotal = total || ( estimate?.total_charge || 0 )

  useEffect( () => {
    onLoad?.()
  }, [] )

  if ( paymentTotal === 0 ) return null

  return (
    <div
      className="flex flex-col w-full gap-3 max-w-2xl mx-auto px-2 mb-8"
      id="payment-plan"
    >
      <p className="sm:text-3xl md:text-[35px] font-semibold font-inter text-[#0057A8] text-center leading-10 mb-5">
        {`Select Your Payment Plan`}
      </p>
      <SleepSelectOption
        selected={splitPayment !== null && !splitPayment}
        onClick={() => setSplitPayment( false )}
        data-testid="snl-sleep-select-one"
      >
        <div className="flex gap-2">
          <SfRadio
            checked={splitPayment !== null && !splitPayment}
            onChange={() => {
              // Radio state is managed by parent component's onClick handler
              // This empty handler prevents React warnings for controlled inputs
            }}
          />
          <p className="font-light">
            {`One-Time Payment of `}
            <span className="font-semibold">{`$${paymentTotal.toFixed( 2 )}`}</span>
          </p>
        </div>
      </SleepSelectOption>
      <SleepSelectOption
        selected={splitPayment !== null && splitPayment}
        onClick={() => setSplitPayment( true )}
        data-testid="snl-sleep-select-monthly"
      >
        <div className="flex flex-col gap-3">
          <div className="flex gap-2">
            <SfRadio
              checked={splitPayment !== null && splitPayment}
              onChange={() => {
                // Radio state is managed by parent component's onClick handler
                // This empty handler prevents React warnings for controlled inputs
              }}
            />
            <div className="flex flex-col">
              <p className="font-light">
                {`${Math.ceil( numberOfMonths )} Monthly Payments of `}
                <span className="font-semibold">{`$${(
                  paymentTotal / numberOfMonths
                ).toFixed( 2 )}`}</span>
              </p>
              <p>{`($${paymentTotal.toFixed( 2 )} over ${numberOfMonths})`}</p>
            </div>
          </div>
        </div>
      </SleepSelectOption>
    </div>
  )
}

export default PaymentPlan